import { FaEnvelope, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { MdCheckCircle } from "react-icons/md";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import { homeAboutStats } from "./HomeAboutSection";
import { snjContact } from "./Footer";
import heroImage from "../assets/construction3.png";
import civilImage from "../assets/civil engineering (1).jpg";
import designImage from "../assets/construction design (1).jpg";
import engineerOne from "../assets/engineer1.png";
import engineerTwo from "../assets/engineer2.png";
import engineerThree from "../assets/engineer3.png";
import passportImage from "../assets/passport.jpg";
import buildingWorkLicence from "../assets/building work licence.png";
import civilWorkLicence from "../assets/civil work licence.png";
import certificateOfIncorporation from "../assets/certificate of incorporation.png";
import tinCertificate from "../assets/tin.png";
import vatCertificate from "../assets/vat certificate.png";
import taxClearance from "../assets/tax clearance.png";
import crbCivilCertificate from "../assets/crb civil certificate.png";
import crbBuildingCertificate from "../assets/crb building certificate.png";
import engineers from "../assets/engineers.jpg";

const missionPoints = [
  "Provide high-quality construction services that meet international standards",
  "Complete projects on time and within budget",
  "Build strong and lasting relationships with clients and stakeholders",
  "Promote safety and environmental responsibility in all operations",
];

const visionPoints = [
  "Lead with trusted building and civil engineering solutions",
  "Deliver durable infrastructure across Tanzania and beyond",
  "Recognize client needs through practical innovation",
];

const coreValues = [
  {
    title: "Integrity",
    text: "Honesty and transparency in all dealings.",
  },
  {
    title: "Quality",
    text: "Superior workmanship across construction scopes.",
  },
  {
    title: "Safety",
    text: "Safe working environments on every project site.",
  },
  {
    title: "Innovation",
    text: "Modern construction techniques and practical solutions.",
  },
  {
    title: "Customer Satisfaction",
    text: "Client needs and expectations remain the priority.",
  },
];

const wheelWords = [
  "Integrity",
  "Quality",
  "Safety",
  "Innovation",
  "Satisfaction",
];

const technicalPersonnel = [
  {
    name: "Joseph Hassan",
    qualification: "Electrical Technician",
    experience: "15 years",
    position: "Managing Director",
  },
  {
    name: "Innocent Bernard",
    qualification: "BSc. Civil Engineering",
    experience: "25 years",
    position: "Company Consultant",
  },
  {
    name: "Eng. Saburi Kaluse",
    qualification: "BSc. Civil Engineering",
    experience: "13 years",
    position: "Technical Director",
  },
  {
    name: "Mudrick Omary",
    qualification: "Civil Technician",
    experience: "5 years",
    position: "Civil Technician",
  },
  {
    name: "Jennifer Mchome",
    qualification: "Diploma in BA",
    experience: "25 years",
    position: "Finance",
  },
  {
    name: "Hamis Mataturu",
    qualification: "Adv. Diploma in Accountancy",
    experience: "12 years",
    position: "Accountant",
  },
  {
    name: "Hafidhi Abubakari",
    qualification: "Cert. Water Supply and Sanitation",
    experience: "5 years",
    position: "Water Technician",
  },
  {
    name: "Zakayo Mchome",
    qualification: "Bachelor Procurement and Supplier",
    experience: "5 years",
    position: "Procurement Officer",
  },
  {
    name: "Beatrice Hassan",
    qualification: "Certificate in Accountant",
    experience: "5 years",
    position: "Assistant Accountant",
  },
  {
    name: "Hassan J. Tandala",
    qualification: "BSc. Architecture",
    experience: "4 years",
    position: "Architect",
  },
  {
    name: "Albaraka Mwanga",
    qualification: "BSc. Quantity Surveyor",
    experience: "8 years",
    position: "Quantity Surveyor",
  },
];

const leadershipBranches = [
  {
    title: "Managing Director",
    children: ["Company Consultant", "Company Secretary", "Marketing Manager"],
  },
  {
    title: "Technical Director",
    children: [
      {
        title: "Project Manager",
        children: [
          "Engineers",
          "Technicians",
          "Plant Foreman",
          "Skilled Labours",
        ],
      },
    ],
  },
  {
    title: "Finance Director",
    children: ["Accountant"],
  },
];

const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/",
    Icon: FaInstagram,
    external: true,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/",
    Icon: FaLinkedinIn,
    external: true,
  },
  {
    label: "Email",
    href: `mailto:${snjContact.email}`,
    Icon: FaEnvelope,
    external: false,
  },
];

const antiBriberyPolicies = [
  {
    title: "Anti-Bribery Policy",
    text:
      "The Governing Board of Directors meeting held on 12th February 2013 gave a resolution on Anti-Bribery Policy to be guided, adhered to, and complied with by all owners, users, staff, and shareholders of SNJ Tanzania Limited effective from 15th February 2013.",
    points: [
      "The policy applies to owners, users, staff, and shareholders",
      "It supports fair and responsible conduct during company operations",
      "It guides company behavior during tendering, acquisition, and project execution",
    ],
  },
  {
    title: "Company Anti-Bribery Policy",
    text:
      "Directors, staff, sub-contractors, and agents are strictly prohibited from giving, promising, offering, or facilitating improper inducements or rewards to public officers, government agents, consultants, relations, or business associations in connection with any bid or contract.",
    points: [
      "No bribes may be given or promised to government or non-government officials",
      "No improper inducement or reward may be offered directly or indirectly",
      "All directors, staff, sub-contractors, and agents must comply with the policy",
      "Non-compliance may lead to stern company action and legal proceedings",
    ],
  },
];

const legalCertificates = [
  {
    title: "Building Work License",
    image: buildingWorkLicence,
  },
  {
    title: "Civil Works License",
    image: civilWorkLicence,
  },
  {
    title: "Certificate of Incorporation",
    image: certificateOfIncorporation,
  },
  {
    title: "TIN",
    image: tinCertificate,
  },
  {
    title: "VAT Certificate",
    image: vatCertificate,
  },
  {
    title: "Tax Clearance",
    image: taxClearance,
  },
  {
    title: "CRB Civil Certificate",
    image: crbCivilCertificate,
  },
  {
    title: "CRB Building Certificate",
    image: crbBuildingCertificate,
  },
];

function WordWheel() {
  return (
    <div className="tgm-word-wheel" aria-hidden="true">
      {wheelWords.map((word, index) => (
        <span
          key={`${word}-${index}`}
          style={{ "--wheel-angle": `${index * (360 / wheelWords.length)}deg` }}
        >
          {word}
        </span>
      ))}
    </div>
  );
}

function CheckList({ items }) {
  return (
    <MotionGroup as="ul" className="tgm-about-check-list" stagger={0.045}>
      {items.map((item) => (
        <MotionItem as="li" key={item}>
          <MdCheckCircle />
          <span>{item}</span>
        </MotionItem>
      ))}
    </MotionGroup>
  );
}

function ChartBranch({ branch }) {
  return (
    <div className="tgm-leadership-column">
      <div className="tgm-chart-node tgm-chart-node-primary">
        {branch.title}
      </div>
      <div className="tgm-chart-stack">
        {branch.children.map((child) => {
          if (typeof child === "string") {
            return (
              <div className="tgm-chart-node" key={child}>
                {child}
              </div>
            );
          }

          return (
            <div className="tgm-chart-nested" key={child.title}>
              <div className="tgm-chart-node">{child.title}</div>
              <div className="tgm-chart-subgrid">
                {child.children.map((item) => (
                  <div
                    className="tgm-chart-node tgm-chart-node-small"
                    key={item}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Overview() {
  return (
    <>
      <PageHero
        eyebrow="About SNJ"
        title="A trusted construction company delivering durable infrastructure solutions."
        text="SNJ Tanzania Limited is a professional construction company based in Tanzania, dedicated to high-quality building and civil engineering solutions."
        image={civilImage}
      />

      <section className="tgm-about-story-hero">
        <div className="container">
          <div className="tgm-about-story-grid">
            <MotionGroup className="tgm-about-story-copy" stagger={0.08}>
              <MotionReveal
                as="p"
                className="tgm-about-breadcrumb"
                variant="soft"
              >
                Home / About
              </MotionReveal>
              <MotionText as="h1" text="Crafting Excellence Together" />
              <MotionReveal as="p" variant="soft">
                SNJ Tanzania Limited is a professional construction company
                based in Tanzania, dedicated to delivering high-quality building
                and civil engineering solutions.
              </MotionReveal>
              <MotionReveal as="p" variant="soft">
                We provide reliable, efficient, and cost-effective services
                across residential construction, commercial construction, civil
                works, renovation, water projects, project management, and
                design support.
              </MotionReveal>
            </MotionGroup>

            <MotionReveal className="tgm-about-story-media" variant="image">
              <img src={engineers} alt="SNJ Tanzania construction team" />
              <WordWheel />
            </MotionReveal>
          </div>

          <MotionReveal className="tgm-about-statement">
            <p>
              At SNJ Tanzania Limited, we combine technical knowledge with
              practical expertise to deliver durable, high-quality structures.
              Modern equipment, quality materials, skilled workmanship, and
              efficient project management keep every client objective in clear
              focus.
            </p>
          </MotionReveal>

          <MotionGroup className="tgm-about-stat-row" stagger={0.08}>
            {homeAboutStats.map((stat) => (
              <MotionItem className="tgm-about-stat" key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </MotionItem>
            ))}
          </MotionGroup>
        </div>
      </section>

      <section className="tgm-section tgm-about-profile-section">
        <div className="container">
          <div className="tgm-about-feature-row">
            <MotionReveal className="tgm-about-collage" variant="image">
              <img
                className="tgm-about-collage-main"
                src={designImage}
                alt="Construction design planning"
              />
              <img
                className="tgm-about-collage-inset"
                src={engineerTwo}
                alt="SNJ Tanzania site supervision"
              />
            </MotionReveal>

            <MotionGroup className="tgm-about-feature-copy" stagger={0.08}>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Our Mission
              </MotionReveal>
              <MotionText
                as="h2"
                text="Build with quality, timing, safety, and trust."
              />
              <MotionReveal as="p" variant="soft">
                Our mission is to provide construction services that meet
                international standards while protecting client budgets,
                schedules, relationships, and site responsibility.
              </MotionReveal>
              <CheckList items={missionPoints} />
            </MotionGroup>
          </div>

          <div className="tgm-about-feature-row tgm-about-feature-row-reverse">
            <MotionGroup className="tgm-about-feature-copy" stagger={0.08}>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Our Vision
              </MotionReveal>
              <MotionText
                as="h2"
                text="Trusted construction solutions across Tanzania and beyond."
              />
              <MotionReveal as="p" variant="soft">
                SNJ Tanzania Limited aims to be a leading and trusted
                construction company, recognized for high-quality, durable, and
                innovative infrastructure solutions.
              </MotionReveal>
              <CheckList items={visionPoints} />
            </MotionGroup>

            <MotionReveal
              className="tgm-about-collage tgm-about-collage-right"
              variant="image"
            >
              <img
                className="tgm-about-collage-main"
                src={civilImage}
                alt="Civil engineering construction works"
              />
              <img
                className="tgm-about-collage-inset"
                src={engineerThree}
                alt="SNJ Tanzania field team"
              />
            </MotionReveal>
          </div>

          <MotionGroup className="tgm-core-value-grid" stagger={0.08}>
            {coreValues.map((value) => (
              <MotionItem as="article" key={value.title}>
                <span>{value.title}</span>
                <p>{value.text}</p>
              </MotionItem>
            ))}
          </MotionGroup>
        </div>
      </section>

      <CallToAction />
    </>
  );
}

function Team() {
  return (
    <>
      <PageHero
        eyebrow="Team"
        title="Technical personnel with clear leadership lines."
        text="SNJ Tanzania Limited brings together directors, engineers, technicians, finance, procurement, and specialist support for dependable construction delivery."
        image={heroImage}
      />

      <section className="tgm-section tgm-team-page tgm-team-roster">
        <div className="container">
          <MotionGroup className="tgm-team-display-head" stagger={0.08}>
            <div>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Key Personnel
              </MotionReveal>
              <MotionText as="h2" text="Crafting Excellence as a Team" />
              <MotionReveal as="p" variant="soft">
                The company profile lists a multidisciplinary technical team
                covering leadership, civil engineering, finance, procurement,
                architecture, quantity surveying, water works, and site
                execution.
              </MotionReveal>
            </div>
          </MotionGroup>

          <MotionGroup className="tgm-personnel-grid" stagger={0.06}>
            {technicalPersonnel.map((person, index) => (
              <MotionItem
                as="article"
                variant="card"
                className="tgm-personnel-card"
                key={person.name}
                whileHover={{ y: -8 }}
              >
                <div className="tgm-personnel-image">
                  <img src={passportImage} alt={person.name} />
                  <div className="tgm-personnel-socials">
                    {socialLinks.map((link) => (
                      <a
                        href={link.href}
                        key={link.label}
                        aria-label={`${link.label} for ${person.name}`}
                        target={link.external ? "_blank" : undefined}
                        rel={link.external ? "noreferrer" : undefined}
                      >
                        <link.Icon />
                      </a>
                    ))}
                  </div>
                </div>
                <h3>{person.name}</h3>
                <span>{person.position}</span>
                <p>{person.qualification}</p>
                <small>{person.experience} experience</small>
              </MotionItem>
            ))}
          </MotionGroup>

          <div className="tgm-leadership-section">
            <MotionGroup className="tgm-section-head" stagger={0.08}>
              <div>
                <MotionReveal
                  as="p"
                  className="tgm-section-kicker"
                  variant="soft"
                >
                  Leadership Tree
                </MotionReveal>
                <MotionText
                  as="h2"
                  text="Organization structure for project control."
                />
              </div>
              <MotionReveal as="p" variant="soft" delay={0.12}>
                The leadership tree follows the company profile, placing the
                board above managing, technical, and finance leadership before
                the project delivery and support roles.
              </MotionReveal>
            </MotionGroup>

            <MotionReveal className="tgm-leadership-chart" variant="image">
              <div className="tgm-chart-node tgm-chart-top">
                Board of Directors
              </div>
              <div className="tgm-leadership-branches">
                {leadershipBranches.map((branch) => (
                  <ChartBranch branch={branch} key={branch.title} />
                ))}
              </div>
            </MotionReveal>
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}

function Policies() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Legal documents and anti-bribery commitments."
        text="SNJ Tanzania Limited maintains documented anti-bribery rules and formal company certificates that support responsible construction operations."
        image={heroImage}
      />

      <section className="tgm-section tgm-policies-page">
        <div className="container">
          <MotionGroup className="tgm-section-head" stagger={0.08}>
            <div>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Anti-Bribery
              </MotionReveal>
              <MotionText
                as="h2"
                text="Policies from the company profile."
              />
            </div>
            <MotionReveal as="p" variant="soft" delay={0.12}>
              These policy summaries follow the company profile and clarify the
              conduct expected from directors, staff, sub-contractors, and
              agents.
            </MotionReveal>
          </MotionGroup>

          <MotionGroup className="tgm-policy-grid tgm-legal-policy-grid" stagger={0.08}>
            {antiBriberyPolicies.map((policy, index) => (
              <MotionItem
                as="article"
                variant="card"
                className="tgm-policy-card"
                key={policy.title}
              >
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{policy.title}</h3>
                <p>{policy.text}</p>
                <ul>
                  {policy.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </MotionItem>
            ))}
          </MotionGroup>

          <div className="tgm-legal-certificates">
            <MotionGroup className="tgm-section-head" stagger={0.08}>
              <div>
                <MotionReveal
                  as="p"
                  className="tgm-section-kicker"
                  variant="soft"
                >
                  Certificates
                </MotionReveal>
                <MotionText
                  as="h2"
                  text="Company legal status and registrations."
                />
              </div>
              <MotionReveal as="p" variant="soft" delay={0.12}>
                The certificate gallery presents the legal and regulatory
                documents included in the company profile.
              </MotionReveal>
            </MotionGroup>

            <MotionGroup className="tgm-certificate-grid" stagger={0.06}>
              {legalCertificates.map((certificate, index) => (
                <MotionItem
                  as="figure"
                  variant="card"
                  className="tgm-certificate-card"
                  key={certificate.title}
                >
                  <div>
                    <img src={certificate.image} alt={certificate.title} />
                  </div>
                  <figcaption>{certificate.title}</figcaption>
                </MotionItem>
              ))}
            </MotionGroup>
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}

export default function AboutUsContent(props) {
  const { section = "overview" } = props;

  if (section === "team") {
    return <Team />;
  }

  if (section === "policies") {
    return <Policies />;
  }

  return <Overview />;
}
